(() => {
  'use strict';

  if (customElements.get('coffee-calculator')) {
    return;
  }

  class CoffeeCalculator extends HTMLElement {

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;

      this.euro = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      this.integer = new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: 0
      });

      this.decimal = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
      });

      this.cacheElements();

      this.addEventListener(
        'input',
        this.handleInput.bind(this)
      );

      this.calculate();
    }


    cacheElements() {

      this.employeesInput =
        this.querySelector('[data-employees]');

      this.cupsInput =
        this.querySelector('[data-cups]');

      this.daysInput =
        this.querySelector('[data-days]');

      this.doseInput =
        this.querySelector('[data-dose]');

      this.coffeePriceInput =
        this.querySelector('[data-coffee-price]');

      this.systemCostInput =
        this.querySelector('[data-system-cost]');


      this.monthlyCupsOutput =
        this.querySelector('[data-monthly-cups]');

      this.coffeeKgOutput =
        this.querySelector('[data-coffee-kg]');

      this.totalCostOutput =
        this.querySelector('[data-total-cost]');

      this.costPerCupOutput =
        this.querySelector('[data-cost-per-cup]');

      this.costPerEmployeeOutput =
        this.querySelector('[data-cost-per-employee]');

      this.recommendationOutput =
        this.querySelector('[data-recommendation]');

      this.recommendationTextOutput =
        this.querySelector('[data-recommendation-text]');

      this.cta =
        this.querySelector('[data-calculator-cta]');
    }


    handleInput(event) {

      if (!event.target.matches('input')) {
        return;
      }

      this.calculate();
    }


    number(element, fallback = 0) {

      if (!element) {
        return fallback;
      }

      const value =
        parseFloat(element.value);

      return Number.isFinite(value)
        ? value
        : fallback;
    }


    dataNumber(name, fallback = 0) {

      const raw =
        this.dataset[name];

      if (!raw) {
        return fallback;
      }

      const normalized =
        raw.replace(',', '.');

      const value =
        parseFloat(normalized);

      return Number.isFinite(value)
        ? value
        : fallback;
    }


    getRecommendation(dailyCups) {

      if (dailyCups <= 40) {

        return {
          title: 'Kaffeesystem Compact',
          text: 'Ideal für kleinere Cafés oder Büros mit moderatem Kaffeeverbrauch.',
          link: '/pages/das-passende-kaffeesystem-fuer-unternehmen#block-id-image_Qw8Kcm',
          linkText: 'Zu den Beispielgeräten'
        };

      }


      if (dailyCups <= 100) {

        return {
          title: 'Professional Kaffeesystem',
          text: 'Geeignet für Unternehmen, Coffeeshops oder Hotels mit regelmäßigem Verbrauch und höherer Getränkevielfalt.',
          link: '/pages/das-passende-kaffeesystem-fuer-unternehmen#shopify-section-template--32420102865221__custom_content_yNgrRN',
          linkText: 'Zu den Beispielgeräten'
        };

      }


      if (dailyCups <= 200) {

        return {
          title: 'Performance Kaffeesystem',
          text: 'Für Standorte mit hoher täglicher Auslastung. Technologisch anspruchsvoll, leistungsfähig und temperaturstabil.',
          link: '/pages/das-passende-kaffeesystem-fuer-unternehmen#shopify-section-template--32420102865221__custom_content_tWdiGY',
          linkText: 'Zu den Beispielgeräten'
        };

      }


      return {
        title: 'Professional / Multi-System',
        text: 'Für diesen Bedarf empfehlen wir eine individuelle Planung mit einem leistungsstarken System oder mehreren Geräten.',
        link: '/pages/das-passende-kaffeesystem-fuer-unternehmen',
        linkText: 'Zu den Beispielgeräten'
      };
    }


    calculate() {

      const employees =
        this.number(
          this.employeesInput
        );

      const cupsPerEmployee =
        this.number(
          this.cupsInput
        );

      const workingDays =
        this.number(
          this.daysInput
        );

      const gramsPerCup =
        this.number(
          this.doseInput,
          8
        );


      const coffeePrice =
        this.coffeePriceInput
          ? this.number(
              this.coffeePriceInput,
              this.dataNumber('coffeePrice', 22)
            )
          : this.dataNumber(
              'coffeePrice',
              22
            );


      const monthlySystemCost =
        this.systemCostInput
          ? this.number(
              this.systemCostInput,
              this.dataNumber('systemCost', 200)
            )
          : this.dataNumber(
              'systemCost',
              200
            );


      const dailyCups =
        employees *
        cupsPerEmployee;


      const monthlyCups =
        dailyCups *
        workingDays;


      const coffeeKg =
        (
          monthlyCups *
          gramsPerCup
        ) / 1000;


      const coffeeCost =
        coffeeKg *
        coffeePrice;


      const totalMonthlyCost =
        coffeeCost +
        monthlySystemCost;


      const costPerCup =
        monthlyCups > 0
          ? totalMonthlyCost / monthlyCups
          : 0;


      const costPerEmployee =
        employees > 0
          ? totalMonthlyCost / employees
          : 0;


      if (this.monthlyCupsOutput) {
        this.monthlyCupsOutput.textContent =
          this.integer.format(monthlyCups);
      }


      if (this.coffeeKgOutput) {
        this.coffeeKgOutput.textContent =
          `${this.decimal.format(coffeeKg)} kg`;
      }


      if (this.totalCostOutput) {
        this.totalCostOutput.textContent =
          this.euro.format(totalMonthlyCost);
      }


      if (this.costPerCupOutput) {
        this.costPerCupOutput.textContent =
          this.euro.format(costPerCup);
      }


      if (this.costPerEmployeeOutput) {
        this.costPerEmployeeOutput.textContent =
          this.euro.format(costPerEmployee);
      }


      const recommendation =
        this.getRecommendation(
          dailyCups
        );


      if (this.recommendationOutput) {

        this.recommendationOutput.textContent =
          recommendation.title;

      }


      /*
       * Empfehlungstext + Link
       * direkt in derselben Zeile ausgeben
       */
      if (this.recommendationTextOutput) {

        this.recommendationTextOutput.textContent =
          recommendation.text + ' ';


        const link =
          document.createElement('a');


        link.href =
          recommendation.link;


        link.textContent =
          recommendation.linkText || 'Mehr erfahren';


        link.setAttribute(
          'data-recommendation-link',
          ''
        );


        /*
         * Design vom Empfehlungstext übernehmen
         */
        link.style.fontSize =
          'inherit';

        link.style.fontFamily =
          'inherit';

        link.style.fontWeight =
          'inherit';

        link.style.lineHeight =
          'inherit';


        /*
         * Der Linktext selbst soll
         * nicht umbrechen
         */
        link.style.whiteSpace =
          'nowrap';


        /*
         * Link direkt hinter den Satz setzen
         */
        this.recommendationTextOutput.appendChild(
          link
        );
      }


      this.updateCTA({
        employees,
        dailyCups,
        monthlyCups,
        coffeeKg,
        totalMonthlyCost,
        costPerCup,
        recommendation
      });
    }


    updateCTA(data) {

      if (!this.cta) {
        return;
      }


      const originalUrl =
        this.cta.dataset.originalUrl;


      if (!originalUrl) {
        return;
      }


      try {

        const url =
          new URL(
            originalUrl,
            window.location.origin
          );


        url.searchParams.set(
          'mitarbeiter',
          Math.round(data.employees)
        );


        url.searchParams.set(
          'tassen_tag',
          Math.round(data.dailyCups)
        );


        url.searchParams.set(
          'tassen_monat',
          Math.round(data.monthlyCups)
        );


        url.searchParams.set(
          'kaffee_kg',
          data.coffeeKg.toFixed(1)
        );


        url.searchParams.set(
          'gesamtkosten',
          data.totalMonthlyCost.toFixed(2)
        );


        url.searchParams.set(
          'kosten_tasse',
          data.costPerCup.toFixed(2)
        );


        url.searchParams.set(
          'systemklasse',
          data.recommendation.title
        );


        this.cta.href =
          url.toString();

      } catch (error) {

        console.warn(
          'Kaffee-Kostenrechner: CTA konnte nicht aktualisiert werden.',
          error
        );

      }
    }
  }


  customElements.define(
    'coffee-calculator',
    CoffeeCalculator
  );

})();